<template>
  <el-table
    :data="data"
    style="width: 100%"
    border
    stripe
    size="small"
  >
    <el-table-column
      prop="asTypeName"
      :label="$t('centralizedPurchase.serviceType')"
      align="center"
    />
    <el-table-column
      prop="asName"
      :label="$t('centralizedPurchase.appName')"
      align="center"
    />
    <el-table-column
      prop="asCount"
      :label="$t('centralizedPurchase.replicas')"
      align="center"
    />
    <el-table-column
      :label="$t('centralizedPurchase.image')"
      align="center"
    >
      <template slot-scope="scope">
        {{ scope.row.imagesName }}:{{ scope.row.imagesVersion }}
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('centralizedPurchase.createTime')"
      align="center"
    >
      <template slot-scope="scope">
        {{ formatUTCTime(scope.row.createTime) }}
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('centralizedPurchase.status')"
      align="center"
    >
      <template slot-scope="scope">
        <el-tag
          :type="getStatusTagType(scope.row.state)"
          size="small"
        >
          {{ scope.row.stateName }}
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column
      :label="$t('centralizedPurchase.operations')"
      align="center"
      width="400"
    >
      <template slot-scope="scope">
        <el-button-group>
          <el-button
            size="mini"
            @click="$emit('control', scope.row)"
          >
            {{ $t('centralizedPurchase.console') }}
          </el-button>
          <el-button
            size="mini"
            @click="$emit('upgrade', scope.row)"
          >
            {{ $t('centralizedPurchase.upgradeDowngrade') }}
          </el-button>
          <el-button
            v-if="scope.row.state === '10012'"
            size="mini"
            type="success"
            @click="$emit('start', scope.row)"
          >
            {{ $t('centralizedPurchase.start') }}
          </el-button>
          <el-button
            v-else
            size="mini"
            type="danger"
            @click="$emit('stop', scope.row)"
          >
            {{ $t('centralizedPurchase.stop') }}
          </el-button>
          <el-button
            size="mini"
            @click="$emit('copy', scope.row)"
          >
            {{ $t('centralizedPurchase.copy') }}
          </el-button>
          <el-button
            v-if="scope.row.state === '10012'"
            size="mini"
            type="danger"
            @click="$emit('delete', scope.row)"
          >
            {{ $t('centralizedPurchase.delete') }}
          </el-button>
          <el-button
            v-if="scope.row.state !== '10012'"
            size="mini"
            @click="$emit('log', scope.row)"
          >
            {{ $t('centralizedPurchase.logs') }}
          </el-button>
        </el-button-group>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'CentralizedPurchaseTable',
  props: {
    data: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    formatUTCTime(time) {
      if (!time) return ''
      return new Date(time).toLocaleString()
    },
    getStatusTagType(state) {
      switch (state) {
        case '10015': return 'success'
        case '10014': return 'warning'
        default: return 'danger'
      }
    }
  }
}
</script>

<style scoped>
.el-button-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}
</style>